import { type Meta } from '../types/docs';
import { AGENT_ONBOARDING_AUDIENCE_META_PARAM, AGENT_ONBOARDING_WALKTHROUGH_STEPS } from './agentOnboardingAnalytics';
import { WORKSPACE_AGENT_ANALYTICS_CATEGORY_META_PARAM } from './workspaceAgentAnalytics';

const META: Meta = {
  description: 'Skip intro is used from any walkthrough step',
  name: 'agent_onboarding_skipped',
  params: [
    WORKSPACE_AGENT_ANALYTICS_CATEGORY_META_PARAM,
    {
      description: 'The walkthrough step that was on screen when Skip intro was used',
      name: 'step',
      required: true,
      type: 'enum',
      values: [...AGENT_ONBOARDING_WALKTHROUGH_STEPS],
    },
    AGENT_ONBOARDING_AUDIENCE_META_PARAM,
  ],
};

export default META;
